<template>
	<div class="footers">
		<footer class="main-footer">
			<div class="row">
				<div class="columns column3">
					<div class="footer-logo" />
				</div>
				<div class="columns column3">
					<h4>{{ $t('footerAddress') }}</h4>
					<p class="address">
						<span>{{ defaults[locale].website.hotelName }}</span>
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
						<span>{{ defaults[locale].website.country }}</span>
					</p>
				</div>
				<div class="columns column3">
					<h4>{{ $t('footerContact') }}</h4>
					<p>
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<font-awesome-icon class="icon" icon="fal fa-phone" size="1x" />
							<span>{{ defaults[locale].website.phone }}</span>
						</a>
						<a :href="`mailto:${defaults[locale].website.email}`">
							<font-awesome-icon class="icon" icon="fal fa-envelope" size="1x" />
							<span>{{ defaults[locale].website.email }}</span>
						</a>
						<social-media :socials="socials" />
					</p>
				</div>
				<div class="columns column3">
					<h4>{{ $t('footerNavigate') }}</h4>
					<p>
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }}
						</nuxt-link>
					</p>
				</div>
			</div>
		</footer>
		<footer class="author-footer">
			<div class="row">
				<div class="columns column12">
					<div class="border" />
					<div class="bottomfooter-row">
						<p class="align-left">
							<a
								href="https://www.porterforhotels.com/hotel-websites"
								target="_blank"
								rel="noopener noreferrer"
								title="Hotel website design by Porter"
							>
								Hotel Website Design
							</a>
							by:
							<a href="https://porterforhotels.com" target="_blank">
								<img class="siteByLogo" :src="$t('siteByLogo')" loading="lazy" alt="" />
								Porter</a
							>
						</p>
						<p class="align-right">
							<span v-for="item in bottomfooter[locale]" :key="item.filename">
								<nuxt-link :to="item.filename">
									{{ item.header }}
								</nuxt-link>
								<span> | </span>
							</span>
							<span v-if="defaults[locale].cookieConsent.published">
								<a href="#" @click.prevent="openConsent">{{ $t('consentOpen') }}</a>
							</span>
						</p>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu, bottomfooter } = footer.value;
const { locale } = useI18n();
const { openConsent } = useCookieConsent();

const { defaults, socials, fetchDefaults } = useDefaults();

await fetchDefaults();
</script>

<style lang="scss" scoped>
.footers {
	color: var(--footer-color);
	background: var(--footer-background-color);
	font-size: calc(var(--body-font-size) - 3px);

	a,
	span {
		color: var(--footer-color);
		text-decoration: none;
	}

	h3,
	h4 {
		color: var(--footer-color);
		letter-spacing: 1px;
		font-size: calc(var(--h3-font-size) - 3px);
	}

	.socials,
	:deep(.socials) {
		margin: 20px 0 0;
	}
}

.main-footer {
	padding: 60px 0;

	p {
		line-height: 24px;
	}

	a,
	span {
		display: flex;
		flex-flow: row nowrap;
		justify-content: flex-start;
		align-items: center;

		svg {
			margin: 0 10px 0 0;
		}
	}

	a:hover {
		text-decoration: underline;
	}

	.footer-logo {
		padding: 0;
		text-decoration: none;
		margin: 0;
		background: url('~/assets/images/logo-depijp-full-white.png') no-repeat center center;
		width: 160px;
		height: 165px;
		background-size: 100%;
	}
}

.bottomfooter-row {
	display: flex;
	align-items: center;

	p {
		width: 100%;
	}
}

.author-footer {
	padding: 0 0 15px;
	text-align: center;
	width: 100%;
	font-size: 11px;

	.border {
		background: var(--dark-background-color);
		width: 100%;
		height: 1px;
		margin: 0 0 15px;
	}

	p {
		margin: 0;
	}

	img {
		max-width: 20px;
		aspect-ratio: 2 / 3;
		margin: 0 1px 0 2px;
	}
}

@media (max-width: 1080px) {
	footer .columns {
		margin: 15px auto;
	}
}

@media (max-width: 580px) {
	footer {
		text-align: center;

		.columns {
			margin: 25px auto;
		}
	}

	.main-footer {
		padding: 50px 0 25px;

		.footer-logo {
			margin: 0 auto 20px;
		}

		a,
		span {
			text-align: center;
			justify-content: center;
		}
	}

	.bottomfooter-row {
		flex-flow: column-reverse wrap;
		align-items: center;

		p {
			width: 100%;
			text-align: center !important;
			margin: 10px auto 0;
		}

		.menu {
			margin: 20px auto;
		}
	}
}
</style>
